import styled, { css } from 'styled-components';
import tw from 'twin.macro';

import { Loader } from '@nw/omega-design-system';
import { colors as Colors, ErrorInfoIcon } from '@nw/shared/ui';

export const EmailFieldConatiner = styled.div`
  ${tw`flex relative flex-col mb-1`};
  width: 100%;
  @media (max-width: 1380px) {
    ${tw`w-full`}
  }
`;
export const BaseTagContainer = styled.div`
  ${tw`flex items-center`}
  right:12px;
  top: 11px;
`;

export const LoadingIcon = styled(Loader)``;
export const OTPVerifiedTag = styled(BaseTagContainer)`
  ${tw`absolute`}
  ${(props) => props.isLoader && `top: 8px;`}
  ${(props) => props.css}
`;
export const OTPVerifiedText = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #16a34a;
  font-size: 16px;
  margin-left: 10px;
`;

export const ResendButton = styled.button`
  ${tw`flex items-center`}
  background-color: ${Colors.white};
  right: 0;
`;

export const ResendButtonText = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.disabled ? Colors.lightCement : Colors.cerulean)};
`;

export const OtpTimer = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #7e858e;
`;
export const ResendOTPWithOTPTimerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 320px;
  align-items: center;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    margin-bottom: 16px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ErrorIcon = styled(ErrorInfoIcon)`
  ${tw`absolute`};
  right: 12px;
  top: 33px;
`;

export const containerClassName = css`
  ${tw`relative`}
`;
